import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './saTheme.css';

/** Shell for the super-admin "Mission Control" master dashboard — matches the
 *  design artifact (framed app, grouped sidebar, ported design system in
 *  saTheme.css). Separate surface from /monitor; reuses the admin token. */
const SECTIONS: { label?: string; items: { label: string; path: string }[] }[] = [
  { items: [{ label: 'Overview', path: '/super-admin' }] },
  { label: 'Facilitators', items: [{ label: 'Effectiveness', path: '/super-admin/facilitators' }] },
  { label: 'Students', items: [
    { label: 'Schools', path: '/super-admin/schools' },
    { label: 'Student groups', path: '/super-admin/student-groups' },
  ] },
  { label: 'Internal (R&D)', items: [{ label: 'Validation', path: '/super-admin/internal-validation' }] },
];

const SuperAdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isActive = (p: string) => (p === '/super-admin' ? pathname === '/super-admin' : pathname.startsWith(p));
  const logout = () => {
    localStorage.removeItem('superAdminToken');
    navigate('/super-admin/login', { replace: true });
  };

  return (
    <div className="sa-scope">
      <div className="app">
        <aside className="side">
          <div className="brand">
            <span className="logo">✦</span>
            <div>
              Mission Control
              <small>super admin</small>
            </div>
          </div>
          {SECTIONS.map((sec, i) => (
            <React.Fragment key={i}>
              {sec.label ? <div className="navlbl">{sec.label}</div> : null}
              {sec.items.map((n) => (
                <div
                  key={n.path}
                  className={`nav${isActive(n.path) ? ' on' : ''}`}
                  onClick={() => navigate(n.path)}
                >
                  {n.label}
                </div>
              ))}
            </React.Fragment>
          ))}
          <div className="logout">
            <div className="nav" onClick={logout}>Log out</div>
          </div>
        </aside>
        <div className="main">{children}</div>
      </div>
    </div>
  );
};

export default SuperAdminLayout;
